// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1205":"ca919476ece0a6d3","4772":"ba04d0876f36e3d1","7563":"1f05b51b11655e0c","9763":"1bc3b1260f6a66ac"}[chunkId] + ".css";
};